import { useState, useEffect } from "react";
import moment from "moment";
moment.locale("es");

export const useRewardsForm = (open: boolean, tabActive: string, data?: any, catalog?: any) => {

    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [form, setForm] = useState({})

	const onHandleChange = (field, field2, e) => {
		let f = form 
		let value = e.target.value

		if(field && !field2){
			if(field  === 'value'){
				let search = catalog.filter(c => c["m"][0]["acumulator_description"] === value)[0]['m'][0]
				f[field] = search["acumulator_description"]
				f["rule_uuid"] = search["accumulator"]
			} else {
				f[field] = field === 'multiplier' ? value ? Number(value) : "" : value
			}
		}
		if(field2){
			field2 === "edate" ?
			f[field][field2] = new Date(new Date(value).setUTCHours(23,59,59,999)).toJSON() :
			f[field][field2] = new Date(value).toJSON()
		}

		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
	}

    const validateForm = (f) => {
        if (f["multiplier"] && (data ? true : f["value"]) && f["period"]["sdate"] && f["period"]["edate"]) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

    useEffect(() => {
		if(tabActive === "promotions" || tabActive === "history_promo"){
			if(open && data){
				setForm(JSON.parse(JSON.stringify({
					title: data["title"] || "",
					description: data["description"] || "",
					uuid: data["uuid"],
					status: "enabled",
					active: true,
					multiplier: data["metadata"]["multiplier"],
					period: data["metadata"]["period"],
				})));
			}
			if(!open){
				setForm(JSON.parse(JSON.stringify({
					multiplier: "",
					rule_uuid: "",
					title: "",
					value: "",
					period: { sdate: "", edate: "" },
					status: "enabled",
					active: true
				})));
				setIsValidForm(true);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open && (tabActive === "promotions" || tabActive === "history_promo")])

    return { form, isValidForm, onHandleChange }
}